import Handlebars from "@cirrus/legacy/vendor-bower/handlebars/handlebars"

Handlebars.registerHelper("defaultAvatar", () => {
  return new Handlebars.SafeString(App.settings.defaultAvatar)
})
